import React from "react";
import { MenuTreeItemProps } from "./types";
import styled from "@emotion/styled";
import { Collapse } from "@mui/material";
import { Loading } from "../Loading";
import MenuItem from "./MenuTreeItem";

const MenuItemChildrens: React.FC<
  MenuTreeItemProps & {
    isLoading?: boolean;
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
  }
> = ({ item, isLoading, isOpen, depth, ...props }) => {
  if (isLoading) {
    return <StyledLoading size="20px" style={{ margin: "1rem" }} />;
  }

  if (!item.children) {
    return null;
  }
  return (
    <>
      {item.children.map((child) => (
        <Collapse in={isOpen} key={`level-${depth}-${child.id}`}>
          <ul
            className={`level-${depth} ${isOpen ? "open" : ""}`}
            key={`level-${depth}-${child.id}`}
          >
            <MenuItem item={child} depth={depth + 1} {...props} />
          </ul>
        </Collapse>
      ))}
    </>
  );
};

export default MenuItemChildrens;

const StyledLoading = styled(Loading)(() => ({
  margin: "1rem",
}));
